import React from "react";

interface VideoProps {
  url: string;
}

const Video: React.FC<VideoProps> = ({ url }) => {
  if (url.includes("youtube.com")) {
    const videoId = url.split("v=")[1];
    const embedURL = `https://www.youtube.com/embed/${videoId}`;
    return <iframe width="100%" src={embedURL} allowFullScreen />;
  } else {
    return (
      <video style={{ width: "100%" }} controls>
        <source type="video/ogg" src={url} />
        <source type="video/m4v" src={url} />
        <source type="video/mp4" src={url} />
      </video>
    );
  }
};

export default Video;
